import 'css-chunksrc/client/pages/exportsPage/resourceAllocatedTimeReport/styles.scss';export default {
  "report": "_report_734wl_1",
  "checked": "_checked_734wl_7",
  "row": "_row_734wl_11",
  "checkbox": "_checkbox_734wl_20",
  "col": "_col_734wl_26",
  "name": "_name_734wl_30",
  "description": "_description_734wl_37",
  "filters": "_filters_734wl_42",
  "group": "_group_734wl_51",
  "label": "_label_734wl_60",
  "button": "_button_734wl_67"
};